angular.module('bmsApp.merrymaids').factory('MMWorksheetSvc', function (CRUDSvc) {

	return {
		getPreferences: function () {
			return CRUDSvc.get('api/settings/merrymaids/worksheet/index');
		},
		setPreferences: function (params) {
			return CRUDSvc.post('api/settings/merrymaids/worksheet/update', params);
		}
	};

});
